import { AncillarySupplierListItem } from "../../../integrated-client/models";

interface ITableData {
  records: Array<AncillarySupplierListItem>;
}

export class TableData implements ITableData {
  records: Array<AncillarySupplierListItem>;

  constructor() {
    this.records = [];
  }
}
